import { GeneralResponse } from '../models/generalResponse'

export function validateTransaction(transactionRepository, contextData, transactionsData) {
  return transactionRepository.validate(contextData, transactionsData).then(data => new GeneralResponse(data));
}